import { gql } from '@apollo/client';

const query = gql`
  query searchProfile($params: JSONObject) {
    searchProfile(params: $params)
  }
`;

module.exports = query;
